import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { HmiStartupWizard } from 'features/hmi/components/HmiStartupWizard';
import { WatchConfigTablesProvider } from 'features/hmi/contexts/WatchConfigTablesContext';
import { WatchSocketProvider } from 'features/hmi/contexts/WatchSocketContext';
import { useIsHmiAvailable } from 'features/hmi/hooks/useIsHmiAvailable';

export const HmiLayout = () => {
  const context = useOutletContext();
  const isHmiAvailable = useIsHmiAvailable();

  if (!isHmiAvailable) {
    return <Navigate to="/" replace />;
  }

  return (
    <WatchSocketProvider>
      <WatchConfigTablesProvider>
        <Outlet context={context} />
        <HmiStartupWizard />
      </WatchConfigTablesProvider>
    </WatchSocketProvider>
  );
};
